



























































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { trackSubmitTrack } from '@/api/track/index'
import { AppModule } from '@/store/modules/app'
import { getCountry, getShippingLists } from '@/api/prescription'

@Component({
  name: 'createTrack',
  components: {}
})
export default class extends Vue {
  get lang() {
    return AppModule.language.toString()
  }

  @Prop({ required: true }) private visible!: string
  @Prop({ required: true }) private detail!: any

  private form = {
    ship_type: '',
    country_id: '',
    tsc_note: ''
  }

  @Watch('detail', { deep: true, immediate: true })
  private onWatchChange() {
    if (this.detail) {
      this.form.ship_type = this.detail.ship_type
      this.form.country_id = this.detail.country_id
      this.form.tsc_note = this.detail.tsc_note || ''
    }
  }

  private rules = {
    tsc_note: [
      { required: true, message: '请输入指定屏蔽轨迹', trigger: 'blur' }
    ]
  }

  public countryList: any = []
  public shippingList: any = []

  public getShippingLists() {
    getShippingLists({}).then((res) => {
      this.shippingList = res.data
    })
  }

  public getCountry() {
    getCountry({}).then((res) => {
      this.countryList = res.data
    })
  }

  handleNoteChange(val: string) {
    const lines = val.split('\n')
    const cleanedLines = lines.map((line: string) => line.trim()).filter((line: string) => line !== '')
    this.form.tsc_note = cleanedLines.join(',')
  }

  public handleCancel() {
    this.$emit('close')
  }

  public handleConfirm() {
    (this.$refs.ruleForm as any).validate((valid: any) => {
      if (valid) {
        const obj = {
          tsc_id: this.detail ? this.detail.tsc_id : undefined,
          ship_type: this.form.ship_type,
          country_id: this.form.country_id,
          tsc_note: this.form.tsc_note
        }
        trackSubmitTrack(obj).then(() => {
          this.$message({
            message: '提交成功',
            type: 'success'
          })
          this.$emit('close')
        })
      } else {
        return false
      }
    })
  }

  created() {
    this.getShippingLists()
    this.getCountry()
  }

  handleClose() {
    this.$emit('close')
  }
}
